import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  id: "app"
};
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
import { reactive, watch, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
const __default__ = {
  name: 'App'
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const whitePath = ['/login', '/index', '/'];
    const {
      locale
    } = reactive({
      locale: zhCn
    });

    // 获取需要缓存的组件列表
    const cachedViews = computed(() => {
      console.log('当前缓存的视图组件:', store.state.cachedViews);
      return store.state.cachedViews;
    });
    onMounted(() => {
      console.log('App.vue 已挂载，当前路由:', router.currentRoute.value.path);
      console.log('当前缓存的视图组件:', cachedViews.value);
    });

    // 监听路由变化，更新标签页
    watch(route, to => {
      console.log('路由变化:', to.name, to.path, to.params);
      if (whitePath.indexOf(to.path) === -1) {
        let obj = {
          name: to.name,
          path: to.path,
          params: to.params // 添加路由参数
        };
        store.commit('ADD_TABS', obj);
      }
    }, {
      deep: true,
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component
        }) => [(_openBlock(), _createBlock(_KeepAlive, {
          include: ['Home']
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1024))]),
        _: 1
      })]);
    };
  }
});